// src/components/eventos/views/EventoPublico.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import EventoPublicoConteudo from './EventoPublicoConteudo';

const AlertCircleIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
);

const EventoPublico = ({ supabase }) => {
    const { id } = useParams();
    const [evento, setEvento] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [erro, setErro] = useState(null);

    useEffect(() => {
        const fetchEvento = async () => {
            try {
                const { data, error } = await supabase
                    .from('eventos').select('*').eq('id', id).maybeSingle();
                if (error) throw error;
                if (!data) throw new Error('Evento não encontrado');
                setEvento(data);
                if (data.cliente_id) {
                    const { data: clienteData } = await supabase
                        .from('clientes').select('id, nome, logo_url').eq('id', data.cliente_id).maybeSingle();
                    if (clienteData) setCliente(clienteData);
                }
            } catch (e) {
                setErro(e.message || 'Evento não encontrado');
            } finally {
                setIsLoading(false);
            }
        };
        fetchEvento();
        const interval = setInterval(fetchEvento, 10000);
        return () => clearInterval(interval);
    }, [id, supabase]);

    if (isLoading) {
        return (
            <>
                <style>{`@keyframes ep-spin { to { transform: rotate(360deg); } }`}</style>
                <div style={{ minHeight:'100vh', background:'#f0faf6', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Inter',-apple-system,sans-serif" }}>
                    <div style={{ width:'40px', height:'40px', borderRadius:'50%', border:'3px solid #e2e8f0', borderTopColor:'#2CCB90', animation:'ep-spin 0.8s linear infinite' }} />
                </div>
            </>
        );
    }

    if (erro) {
        return (
            <div style={{ minHeight:'100vh', background:'#f0faf6', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Inter',-apple-system,sans-serif", padding:'24px' }}>
                <div style={{ textAlign:'center' }}>
                    <div style={{ color:'#fca5a5', margin:'0 auto 16px', width:'fit-content' }}><AlertCircleIcon /></div>
                    <p style={{ margin:'0 0 6px', fontSize:'20px', fontWeight:700, color:'#1e293b' }}>Evento não encontrado</p>
                    <p style={{ margin:0, fontSize:'14px', color:'#94a3b8' }}>O link pode estar incorreto ou o evento foi removido.</p>
                </div>
            </div>
        );
    }

    return <EventoPublicoConteudo evento={evento} cliente={cliente} />;
};

export default EventoPublico;
